export const APPLY_FALLBACK = 'Não foi possível aplicar o ajuste. Nada foi alterado.';
export const REVERT_FALLBACK = 'Não foi possível reverter o ajuste.';

export const REVERT_SUCCESS = 'Ajuste revertido.';
export const REVERT_REASON = 'Reversão solicitada pelo operacional na tela financeira';

export const applySuccess = (responsibleName) =>
    'Mudanças aplicadas. O valor de ' + responsibleName + ' e a conta do cliente foram atualizados.';
